import React, { useState, useContext } from 'react';
import AulaUserContext, { setAulaSession } from '../aulaUserContext';

const ConfirmarCuenta = (props) => {
    const emailInicial = (props.location.state && props.location.state.email) || '';
    const from = (props.location.state && props.location.state.from) || '/aula';
    const [email, setEmail] = useState(emailInicial);
    const [codigo, setCodigo] = useState('');
    const [error, setError] = useState('');
    const [reenviado, setReenviado] = useState(false);
    const { setAulaAuth } = useContext(AulaUserContext);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        fetch('/aula/auth/confirmar', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            body: JSON.stringify({ email, codigo })
        }).then(async (res) => {
            if (res.status === 200) {
                const data = await res.json();
                setAulaSession(data);
                setAulaAuth({ token: data.token, nombre: data.nombre, rol: data.rol });
                props.history.push(from);
            } else {
                setError('El código no es correcto.');
            }
        });
    };

    const handleReenviar = () => {
        fetch('/aula/auth/reenviar', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            body: JSON.stringify({ email })
        }).then(() => setReenviado(true));
    };

    return (
        <div className="container vh-100 text-center">
            <h3 className="title">Confirmá tu cuenta</h3>
            <p>Te enviamos un código por email. Ingresalo acá abajo para activar tu cuenta.</p>
            <div className="row">
                <div className="col-md-6 mx-auto">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <input type="email" className="form-control" placeholder="Email" value={email}
                                onChange={(e) => setEmail(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="Código de 6 dígitos" value={codigo}
                                onChange={(e) => setCodigo(e.target.value)} required maxLength={6} />
                        </div>
                        <button type="submit" className="btn aula-btn-primary btn-block">Confirmar</button>
                        {error && <span className="d-block text-danger mt-2">{error}</span>}
                        <button type="button" className="btn btn-link mt-2" onClick={handleReenviar}>
                            Reenviar código
                        </button>
                        {reenviado && <span className="d-block text-success">Código reenviado.</span>}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ConfirmarCuenta;
